import css from 'styled-jsx/css';

const styles = css.global`.wrapper-container{width:100%;flex:1}`;

export default styles;